import React from 'react';
import Tag from '../../components/Tag';
import CircularLoader from '../../components/CircularLoading';

const LoadingModal = ({modalData}) => {
    return (
        <>
            <div className='modal-header'>
                <h3 className='text-center mb-8'>Quiz Questions</h3>
                <div className='flex flex-align-center flex-justify-center flex-wrap'>
                    <Tag text={modalData?.categoryTitle} className="m-4" />
                    <Tag text={`${modalData?.num_questions} Questions`} className="m-4" />
                </div>
            </div>
            <div className="modal-body">
                <CircularLoader questionsNum={modalData?.num_questions} questionsType={modalData?.question_type} />
            </div>
        </>
    );
}

export default LoadingModal;